/**
 * チュートリアルアイコンディレクティブ
 * 各設定ページにアイコンとして表示され、チュートリアルの進行状況を示すコンポーネント
 *
 * @description
 * このディレクティブは、指定されたステップキーに対応するチュートリアルステップが
 * 未完了の場合にのみアイコンを表示します。ユーザーが該当ステップを完了すると、
 * アイコンは非表示になります。
 *
 * @requires tutorialService - チュートリアルデータの取得と管理
 *
 * @scope
 * @param {boolean=} isShow - アイコンの表示/非表示を制御（双方向バインディング）
 * @param {string} stepKey - チュートリアルステップのキー
 *                          （例: 'service_setting', 'service_setting_class'）
 *
 * @example
 * <tutorial-icon
 *   is-show="showIcon"
 *   step-key="service_setting">
 * </tutorial-icon>
 *
 * @example
 * <!-- 表示状態を親スコープで管理しない場合 -->
 * <tutorial-icon step-key="contactbook_list"></tutorial-icon>
 */
angular.module('inspinia').directive('tutorialIcon', [
  'tutorialService',
  function (tutorialService) {
    return {
      restrict: 'E',
      scope: {
        isShow: '=?',
        stepKey: '@',
      },
      templateUrl: `src/view/directive/project/tutorial/tutorial_icon.html?${new Date().getTime()}`,
      link: (scope) => {
        // 初期状態は非表示
        scope.isShow = false;
        scope.stepKey = '';

        /**
         * チュートリアルアイコンの表示状態を初期化
         */
        const initializeTutorialIcon = () => {
          // 設定権限がない場合は処理を中断
          if (!scope.$parent.checkAuthority('setting')) {
            scope.isShow = false;
            return;
          }

          // tutorialServiceを使って指定されたステップの情報を取得
          const tutorial = scope.$parent.tutorial;
          const stepInfo = tutorialService.getTutorialStepInfo(tutorial, scope.stepKey);

          // ステップ情報が取得できない場合（チュートリアルOFF、ステップなし等）は非表示
          if (!stepInfo) {
            scope.isShow = false;
            return;
          }

          // ステップが未完了の場合のみ表示
          scope.isShow = stepInfo.isVisible;
        };

        scope.$parent.getMine().then(() => {
          const serviceId = scope.$parent.my.current_service_id
            ? scope.$parent.my.current_service_id
            : scope.$parent.my.service_id;

          scope.$parent.getService(serviceId).then(() => {
            tutorialService.setTutorial(scope.$parent);
            initializeTutorialIcon();
          });
        });
      },
    };
  },
]);
